import type { KnowledgeGap } from '@hostesa/api-client';
import { useT } from '@hostesa/i18n';
import { StatusBadge } from '@hostesa/ui';
import { namespace } from './i18n';

/**
 * KnowledgeIndexStatus — a compact health summary of the hotel knowledge base:
 * how many open questions remain. Color is never the only signal (text label
 * always present).
 */
export function KnowledgeIndexStatus({ gaps }: { gaps: readonly KnowledgeGap[] }) {
  const { t } = useT(namespace);
  const open = gaps.filter((g) => g.status === 'needs_answer').length;

  return (
    <div
      data-testid="knowledge-index-status"
      className="flex items-center gap-3 rounded-lg border border-[var(--color-warm-stone-soft)] bg-[var(--color-canvas)] px-4 py-3"
    >
      <StatusBadge
        data-testid="knowledge-index-gaps-badge"
        status={open > 0 ? 'warning' : 'success'}
        label={open > 0 ? `${open} ${t('gaps.title').toLowerCase()}` : t('gaps.empty')}
      />
    </div>
  );
}
